var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step_1_on",
    "data-name": "step 1 on",
    transform: "translate(-1336 -776.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176646",
    "data-name": "Group 176646",
    transform: "translate(1336.217 777.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9225",
    "data-name": "Ellipse 9225",
    transform: "translate(-0.217 -0.135)",
    fill: "none",
    stroke: "#2253f5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M13.417,13.417A3.709,3.709,0,1,0,9.709,9.709,3.708,3.708,0,0,0,13.417,13.417Zm0,1.854C10.942,15.271,6,16.514,6,18.98v1.854H20.834V18.98C20.834,16.514,15.893,15.271,13.417,15.271Z",
    transform: "translate(1340.5 781.5)",
    fill: "none",
    stroke: "#2253f5",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.65adefe22b6dc9cd166d457a53acebe1.svg";
export { ForwardRef as ReactComponent };